import React from "react";
import { FormContext } from "../contexts";

export const useMultiStep = (data) => {
  const formContext = React.useContext(FormContext);

  return {
    isReadOnly: formContext?.processStep ? formContext?.currentStepElements?.find(e => e.id === data.id) == null : false
  }
}